var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 d-flex align-center"},[_c('v-icon',{attrs:{"small":"","color":"error"}},[_vm._v("mdi-alert")]),_c('span',{staticClass:"pl-4 red--text text-subtitle-2"},[_vm._v(_vm._s(_vm.errorMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }